<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.t-rating
    +e.SVG.svg(
      :width="width",
      :height="height",
    )
      +e.G.chart
      +e.G.overlay-container
    +e.under-container
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import d3 from '@/tools/d3/d3';
import margin from '../../mixins/margin';

export default {
  name: 't-rating',

  mixins: [
    margin,
  ],

  data() {
    return {
      svg: null,
      chart: null,
      overlay: null,
      width: 0,
      height: 0,
    };
  },

  props: {
    // Датасет для отображения
    dataSet: {
      type: Array,
      default: () => [],
    },

    // Функция фильтрации отображаемых стран
    filterFunction: {
      type: Function,
    },

    // Список стран выбранных стран, для которых стоит сразу показать информацию
    selectedСountries: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    padded() {
      const width = this.width - this.margin.left - this.margin.right;
      const height = this.height - this.margin.top - this.margin.bottom;
      return { width, height };
    },

    dataToDisplay() {
      const sortedData = this.dataSet.slice().sort((a, b) => a.rank.y18 - b.rank.y18);
      return sortedData;
    },

    hoverCountry(i) {
      return i;
    },

    selectedСountriesToDisplay() {
      const selectedСountriesToDisplay = [];

      for (let i = 0; i < this.dataToDisplay.length; i += 1) {
        for (let j = 0; j < this.selectedСountries.length; j += 1) {
          if (this.dataToDisplay[i].ISO3 === this.selectedСountries[j].ISO3) {
            selectedСountriesToDisplay.push({
              country: this.dataToDisplay[i],
              index: i,
              height: this.selectedСountries[j].height,
            });
          }
        }
      }

      return selectedСountriesToDisplay;
    },

     ...mapGetters({
      lng: 'lng',
    }),
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    width: function widthChanged() {
      this.initialize();
      // this.update();
    },

    dataSet: function dataChange() {
      this.updateData();
    },

    filterFunction: function filterChange() {
      this.updateData();
    },

    lng: function lngChange() {
      this.updateData();
    },
  },

  methods: {
    country: (c) => {
      const self = this;
      console.log(self.lng);
      return self.lng === 'ua' ? c.name_ua : c.country;
    },

    onResize() {
      this.width = this.$el.offsetWidth;
      this.height = this.$el.offsetHeight;
    },

    initialize() {
      this.svg = d3.select(this.$el.querySelector('svg'))
        .attr('width', this.padded.width)
        .attr('height', this.padded.height);

      this.chart = this.svg.select('.t-rating__chart');
      this.overlay = this.svg.select('.t-rating__overlay-container');

      this.draw();
    },

    draw() {
      // Удаление всех детей у ноды
      this.chart.selectAll('*').remove();
      this.overlay.selectAll('*').remove();

      this.drawPoints();
      this.drawSelected();
      this.drawOverlay();
    },

    drawPoints() {
      const self = this;

      // Пропорция между точкой и промежутком
      const gapProportion = 1;

      const circleProportion = 2;

      // Количество точек
      const size = self.dataToDisplay.length;
      // Размер ячейк
      const celSize = self.padded.width / (size + ((size - 1) * gapProportion));

      // Размер отступа между дельтой и точкой
      const deltaGap = 1.5 * celSize;

      const deltaExtent = d3.extent(self.dataToDisplay, d => Math.abs(d.CPIScore.y18 - d.CPIScore.y17));

      const deltaScale = d3.scaleLinear()
        .domain(deltaExtent)
        .range([0, 0.8 * ((self.padded.height - (2 * celSize)) / 2)]);

      const colorScale = d3.scaleLinear()
        .domain([0, 100])
        .range(['#AE1F23', '#F6EC13']);

      // Отрисовка линий выбраных стран
      self.chart.selectAll('.t-rating__selected_line')
        .data(this.selectedСountriesToDisplay)
        .enter().append('line')
        .attr('x1', d => self.margin.left + (((d.index - 1) * (celSize * (1 + gapProportion))) + ((1 + gapProportion) / 2)))
        .attr('y1', self.padded.height / 2)
        .attr('x2', d => self.margin.left + (((d.index - 1) * (celSize * (1 + gapProportion))) + ((1 + gapProportion) / 2)))
        .attr('y2', (d) => {
          let result;
          if (d.country.CPIScore.y18 >= d.country.CPIScore.y17) {
            result = (self.margin.top + 20) + ((((1 - d.height) * self.padded.height) / 2));
          } else {
            result = ((self.margin.top + self.padded.height) - 20) * d.height;
          }
          return result;
        })
        .attr('stroke', '#ffffff');

      // Отрисовка названий
      self.chart.selectAll('.t-rating__selected_rank')
        .data(this.selectedСountriesToDisplay)
        .enter().append('text')
        .attr('x', d => self.margin.left + (((d.index - 1) * (celSize * (1 + gapProportion))) + ((1 + gapProportion) / 2)))
        .attr('y', (d) => {
          let result;
          if (d.country.CPIScore.y18 >= d.country.CPIScore.y17) {
            result = (self.margin.top + 20) + ((((1 - d.height) * self.padded.height) / 2)) - 10;
          } else {
            result = ((self.margin.top + self.padded.height) - 20) * d.height + 12 + 6;
          }
          return result;
        })
        .text(d => d.country.CPIScore.y18)
        .attr('text-anchor', 'end')
        .attr('font-family', 'sans-serif')
        .attr('font-weight', '600')
        .attr('font-size', '14px')
        .attr('fill', d => colorScale(d.country.CPIScore.y18))
        .attr('transform', 'translate(-6, 0)');

      // Делта изменения номера
      // self.chart.selectAll('.t-rating__selected-rank-delta')
      //   .data(this.selectedСountriesToDisplay)
      //   .enter().append('text')
      //   .attr('x', d => self.margin.left + (((d.index - 1) * (celSize * (1 + gapProportion))) + ((1 + gapProportion) / 2)))
      //   .attr('y', (d) => {
      //     let result;
      //     if (d.country.CPIScore.y18 >= d.country.CPIScore.y17) {
      //       result = (self.margin.top + 20) + ((((1 - d.height) * self.padded.height) / 2)) - 4;
      //     } else {
      //       result = ((self.margin.top + self.padded.height) - 20) * d.height + 12 + 6;
      //     }
      //     return result;
      //   })
      //   .text(d => {
      //     let result = '';

      //     if (d.country.CPIScore.y18 && d.country.CPIScore.y17) {
      //       result = '' + (d.country.CPIScore.y18 - d.country.CPIScore.y17) + '.';
      //       if ((d.country.CPIScore.y18 - d.country.CPIScore.y17) > 0) {
      //         result = '+' + result;
      //       }
      //     }
      //      return result;
      //   })
      //   .attr('text-anchor', 'end')
      //   .attr('font-family', 'sans-serif')
      //   .attr('font-weight', '600')
      //   .attr('font-size', '8px')
      //   .attr('fill', d => colorScale(d.country.CPIScore.y18))
      //   .attr('transform', 'translate(1, -10)');

       // Делта изменения номера
      self.chart.selectAll('.t-rating__selected-CPIScore-delta')
        .data(this.selectedСountriesToDisplay)
        .enter().append('text')
        .attr('x', d => self.margin.left + (((d.index - 1) * (celSize * (1 + gapProportion))) + ((1 + gapProportion) / 2)))
        .attr('y', (d) => {
          let result;
          if (d.country.CPIScore.y18 >= d.country.CPIScore.y17) {
            result = (self.margin.top + 20) + ((((1 - d.height) * self.padded.height) / 2)) - 10;
          } else {
            result = ((self.margin.top + self.padded.height) - 20) * d.height + 12 + 6;
          }
          return result;
        })
        .text(d => {
          let result = '';

          if (d.country.CPIScore.y18 && d.country.CPIScore.y17) {
            result = '' + (d.country.CPIScore.y18 - d.country.CPIScore.y17);
            if ((d.country.CPIScore.y18 - d.country.CPIScore.y17) > 0) {
              result = '+' + result;
            }
          }
           return result;
        })
        .attr('text-anchor', 'end')
        .attr('font-family', 'sans-serif')
        .attr('font-weight', '600')
        .attr('font-size', '8px')
        .attr('fill', d => colorScale(d.country.CPIScore.y18))
        .attr('transform', 'translate(1, 6)');

      self.chart.selectAll('.t-rating__selected_name')
        .data(this.selectedСountriesToDisplay)
        .enter().append('text')
        .attr('x', d => self.margin.left + (((d.index - 1) * (celSize * (1 + gapProportion))) + ((1 + gapProportion) / 2)))
        .attr('y', (d) => {
          let result;
          if (d.country.CPIScore.y18 >= d.country.CPIScore.y17) {
            result = (self.margin.top + 20) + ((((1 - d.height) * self.padded.height) / 2)) - 10;
          } else {
            result = ((self.margin.top + self.padded.height) - 20) * d.height + 12 + 6;
          }
          return result;
        })
        .text((d) => {
          let country = '';

          if (self.lng === 'ua') {
            country = d.country.name_ua;
          } else {
            country = d.country.country;
          }
          return d.country.rank.y18 + '.' + country;
        })
        .attr('text-anchor', 'start')
        .attr('font-family', 'sans-serif')
        .attr('font-size', '12px')
        .attr('transform', 'translate(2, 0)')
        .attr('fill', '#ffffff');


      // Отрисовка точек
      self.chart.selectAll('.t-rating__points')
        .data(this.dataToDisplay)
        .enter().append('rect')
        // .attr('x', d => (d.rank.y18 - 1) * (celSize * (1 + gapProportion)))
        .attr('x', (d, i) => self.margin.left + ((i - 1) * (celSize * (1 + gapProportion))))
        .attr('y', (this.padded.height / 2) - (celSize / 2))
        .attr('width', celSize)
        .attr('height', celSize)
        .attr('fill', (d) => {
          let color = colorScale(d.CPIScore.y18);

          if (this.filterFunction !== null) {
            color = this.filterFunction(d) ? colorScale(d.rank.y18) : '#303030';
          }

          return color;
        })
        .attr('stroke', 'none');

      // Отрисовка дельт
      self.chart.selectAll('.t-rating__delta')
        .data(this.dataToDisplay)
        .enter().append('rect')
        .attr('x', (d, i) => self.margin.left + ((i - 1) * (celSize * (1 + gapProportion))))
        .attr('y', (d) => {
          let y;

          if (d.CPIScore.y18 && d.CPIScore.y17) {
            y = d.CPIScore.y18 - d.CPIScore.y17 > 0 ? ((self.padded.height - celSize) / 2) - deltaGap - deltaScale(Math.abs(d.CPIScore.y18 - d.CPIScore.y17)) : (self.padded.height / 2) + (celSize / 2) + deltaGap;
          } else {
            y = 0;
          }
          return y;
        })
        .attr('width', celSize)
        .attr('height', (d) => {
          let height;
          if (d.CPIScore.y18 && d.CPIScore.y17) {
            height = deltaScale(Math.abs(d.CPIScore.y18 - d.CPIScore.y17));
          } else {
            height = 0;
          }
          return height;
        })
        .attr('fill', d => colorScale(d.CPIScore.y18))
        .attr('stroke', 'none')
        .attr('display', (d) => {
          let result = '';

          if (this.filterFunction !== null) {
            result = this.filterFunction(d) ? '' : 'none';
          }

          return result;
        });

      // Отрисовка выбранных стран
      self.chart.selectAll('.t-rating__selected_pont')
        .data(this.selectedСountriesToDisplay)
        .enter().append('circle')
        .attr('cx', d => self.margin.left + (((d.index - 1) * (celSize * (1 + gapProportion))) + ((1 + gapProportion) / 2)))
        .attr('cy', self.padded.height / 2)
        .attr('r', (celSize * circleProportion) / 2)
        .attr('fill', '#ffffff')
        .attr('stroke', 'none');
    },

    drawOverlay() {
      const self = this;

      self.overlay.selectAll('rect').remove();
    },

    drawSelected() {

    },

    updateData() {
      this.draw();
    },
  },
};
</script>


<style lang="scss">
@import '../../scss/styles';

.t-rating {
  position: relative;
  width: 100%;
  height: 100%;

  &__svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  &__under-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TRating/TRating.vue